import React from 'react'
import { i18n } from 'common'
import { AdminPage } from '../components'

export default class Approved extends AdminPage {
    config = {
        url: 'api/approved',
        columns: [
            {type: 'fold'},
            {type: 'string', title: i18n('approved.client-id'), className: 'table-200p', getter: 'clientId'},
            {type: 'tag-list', title: i18n('approved.scopes'), getter: 'allowedScopes'},
            {type: 'date', title: i18n('approved.creation-date'), getter: 'creationDate'},
            {type: 'date', title: i18n('approved.access-date'), getter: 'accessDate'},
            {type: 'date', title: i18n('approved.timeout-date'), getter: 'timeoutDate'},
            {type: 'actions', allows: {'Revoke': 'api/approved/'}, className: 'table-100p'}
        ]
    }
}
